import React from 'react';
import CardHeader from '../molecules/CardHeader';
import Tile from '../molecules/Tile';
import TileInfo from '../molecules/TileInfo';
import PremiumTile from '../molecules/PremiumTile';
import JerseyTile from '../molecules/JerseyTile';


export default function PlayerCard({ player, onClose, teamName }) {

    // these are the constant stats that are displayed on the player card regardless of the sport
    const Array = [
        { label: "Age", value: player.common_fields.age },
        { label: 'Weight', value: player.common_fields.weight },
        { label: 'Height', value: player.common_fields.height }
    ];

    return (
        <div className='absolute inset-0 bg-white/30 backdrop-blur-lg flex items-center justify-center'>
            <div className={`relative flex flex-col items-center w-80 h-[470px] text-white rounded-3xl`} style={{ backgroundColor: player.common_fields.jersey_color }}>
                <CardHeader onClose={onClose} />

                <div className='flex w-full justify-center mt-4'>
                    <div className='ml-2 stats-container w-2/5 flex flex-col mt-8 items-center'>
                        {Array.map((stat, index) => (
                            <React.Fragment key={index}>
                                <Tile tileData={stat.label} flavor="light" />
                                <TileInfo tileInfoData={stat.value} />
                            </React.Fragment>
                        ))}
                    </div>
                    <div className='pic-container w-3/5 flex flex-col items-center mr-4 mt-4'>
                        <img
                            src={player.common_fields.profile_pic ? player.common_fields.profile_pic : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"}
                            alt={player.common_fields.name}
                            className="rounded-xl h-50 w-50"
                        />
                    </div>
                </div>

                <PremiumTile name={player.common_fields.Name} />

                <div className='flex justify-between w-full mt-4'>
                    <div className='p-2 flex flex-col w-2/3 ml-2'>

                        {Object.entries(player.sport_specific || {}).map(([key, value]) => (
                            <React.Fragment key={key}>
                                <div className="w-24 rounded-full mb-1 text-center text-xs px-2 py-1 bg-black text-white border border-white uppercase">
                                    {key.toUpperCase()} 
                                </div>
                                <div className='ml-2'><TileInfo tileInfoData={value} /></div>
                            </React.Fragment>
                        ))}
                    </div>

                    <JerseyTile jerseyNumber={player.common_fields.jersey_no} />
                </div>
            </div>
        </div>
    )

}